import React, { useRef, useCallback, useState } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/**
 * Canon Corp Campaign — CORALS (World Unseen) medya planı.
 * FB + IG, 3 video, toplam 40.000 ₺ (AHK %10 + Stopaj %15 dahil).
 *
 * 2026-08-24 revizyonu: KPI global'den web sitesinin ilgili alanına YÖNLENDİRME
 * olduğu için üç videonun da hedefi TRAFİK. Awareness kırılımı plandan çıkarıldı.
 *
 * CPM / CPC / izlenme varsayımları uydurma DEĞİL: Canon'un kendi Meta hesabının
 * (act_3256944827800966) canlı Graph API verisinden, LINK_CLICKS hedefli
 * kampanyaların Haz–Ağu 2026 gerçekleşmesinden türetildi. Plan tabanı yalnızca
 * FEED + REELS yerleşimlerinden alındı (176.837 ₺ harcama, 6,42M gösterim);
 * Story hariç — Story tıklama başına ~1,7 kat pahalı ve aylar arası farkın
 * büyük bölümü Story payından kaynaklanıyordu (Tem %45, Ağu %13). Adında "Video" geçen ama statik kreatifli yarışma kampanyaları
 * video oranlarının hesabına KATILMADI (izlenmeleri 0 dönüyor).
 */
export default function CanonCorals2026() {
  const slideRef = useRef(null);
  const [exporting, setExporting] = useState(false);

  const fmtCur = (n) => '₺' + Math.round(Number(n)).toLocaleString('tr-TR');
  const fmtInt = (n) => Math.round(Number(n)).toLocaleString('tr-TR');

  // ── Bütçe kırılımı ────────────────────────────────────────────────────────
  // Merve: "Stopaj & %10 Ajans Hizmet Bedeli dahil olmak üzere 40K bütçemiz."
  // Tasarım kalemi BELİRTİLMEDİ → kırılımda yok, videolar hazır kabul edildi.
  const TOTAL = 40000;
  const AHK_RATE = 0.10;
  const AHK_FEE = Math.round(TOTAL * AHK_RATE);        // 4.000 — Ajans Hizmet Komisyonu
  const MEDIA_BRUT = TOTAL - AHK_FEE;                   // 36.000 (stopaj dahil medya)
  const STOPAJ_RATE = 0.15;
  const STOPAJ = Math.round(MEDIA_BRUT * STOPAJ_RATE);  // 5.400
  const NET = MEDIA_BRUT - STOPAJ;                      // 30.600 — Meta'da gerçek harcanan

  // ── Süre ──────────────────────────────────────────────────────────────────
  // ⚠️ Tarih iletilmedi. 30 günlük akış varsayıldı, onaya açık.
  const START = '2026-09-01';
  const END = '2026-09-30';
  const DAYS = 30;
  const dailyNet = NET / DAYS;
  // Bu plana en yakın harcama seviyesindeki gerçekleşmeden alındı (Ağustos trafik,
  // 48.193 ₺ → 1,66). Temmuz'un 2,08'i 240.889 ₺ harcamaya ait, bu bütçeyi temsil etmez.
  const FREQ = 1.7;

  // ── Video bazında kurgu ───────────────────────────────────────────────────
  // Canon gerçekleşen (canlı API, LINK_CLICKS hedefi, FEED + REELS, Haz–Ağu 2026):
  //   Tüm trafik            → CPM 27,56 · link CPC 1,91 · CTR %1,44  (176.837 ₺)
  //   Trafik × gerçek video → CPM 49,12 · link CPC 2,82 · CTR %1,74  (5.581 ₺)
  //   (Story vb.: CPM 50,87 · CPC 3,32 — plan dışı, gerekçesi sayfada)
  const TR_CPM = 27.56;
  const TR_CPC = 1.91;
  const TR_SAMPLE = 176837;
  const VIEW_RATE = 0.1918;
  const THRU_RATE = 0.0556;
  const LPV_PER_LINK = 0.239;
  const VIDEO_SAMPLE = 5581;
  const VIDEO_CPM = 49.12;
  const VIDEO_CPC = 2.82;

  const videos = [
    {
      key: 'v1',
      title: 'Video 1 — Ana Film',
      role: 'Projeyi tanıtan ana anlatım',
      goal: 'Trafik',
      layer: 'Geniş kitle · soğuk trafik',
      placement: 'IG/FB Feed + Reels',
      share: 0.40,
      cpm: TR_CPM,
      cpc: TR_CPC,
      viewRate: VIEW_RATE,
      thruRate: THRU_RATE,
    },
    {
      key: 'v2',
      title: 'Video 2 — Hikâye',
      role: 'CORALS anlatısının derinleştirilmesi',
      goal: 'Trafik',
      layer: 'İlgi alanı + benzer kitle',
      placement: 'IG/FB Feed + Reels',
      share: 0.30,
      cpm: TR_CPM,
      cpc: TR_CPC,
      viewRate: VIEW_RATE,
      thruRate: THRU_RATE,
    },
    {
      key: 'v3',
      title: 'Video 3 — Yönlendirme',
      role: 'World Unseen sayfasına net çağrı',
      goal: 'Trafik',
      layer: 'Retargeting · ilk iki videoyu izleyenler',
      placement: 'IG/FB Feed + Reels',
      share: null, // kalanı alır
      cpm: TR_CPM,
      cpc: TR_CPC,
      viewRate: VIEW_RATE,
      thruRate: THRU_RATE,
    },
  ];

  let alloc = 0;
  const rows = videos.map((v, i) => {
    const isLast = i === videos.length - 1;
    const budget = isLast ? NET - alloc : Math.round(NET * v.share);
    alloc += budget;
    const impressions = Math.round((budget / v.cpm) * 1000);
    const clicks = Math.round(budget / v.cpc);
    const reach = Math.round(impressions / FREQ);
    const views = Math.round(impressions * v.viewRate);
    const thruplays = Math.round(impressions * v.thruRate);
    return { ...v, budget, impressions, clicks, reach, views, thruplays, lpv: Math.round(clicks * LPV_PER_LINK) };
  });

  const totals = rows.reduce((t, r) => ({
    budget: t.budget + r.budget,
    impressions: t.impressions + r.impressions,
    clicks: t.clicks + r.clicks,
    lpv: t.lpv + r.lpv,
    views: t.views + r.views,
    thruplays: t.thruplays + r.thruplays,
  }), { budget: 0, impressions: 0, clicks: 0, lpv: 0, views: 0, thruplays: 0 });
  const blendedCpm = (totals.budget / totals.impressions) * 1000;
  const blendedCpc = totals.budget / totals.clicks;
  const cpv = totals.budget / totals.views;
  const cptp = totals.budget / totals.thruplays;
  const estReach = Math.round(totals.impressions / FREQ);
  const cplpv = totals.budget / totals.lpv;
  const ctr = (totals.clicks / totals.impressions) * 100;

  // Duyarlılık: plan 3 VİDEO kreatifiyle yayınlanacak; video kreatifinin trafik CPM'i
  // hesabın genel trafik ortalamasının üzerinde.
  const sensImpressions = Math.round((NET / VIDEO_CPM) * 1000);
  const sensClicks = Math.round(NET / VIDEO_CPC);
  const sensDelta = Math.round(((sensImpressions - totals.impressions) / totals.impressions) * 100);

  const layerSummary = rows.map((r) => ({
    key: r.key,
    layer: r.layer,
    budget: r.budget,
    impressions: r.impressions,
    clicks: r.clicks,
    pct: (r.budget / NET) * 100,
  }));

  // ── Takvim ────────────────────────────────────────────────────────────────
  // 3 video kademeli açılır; ana film baştan sona, hikâye 2. haftadan,
  // yönlendirme son 2 haftada (izleyici havuzu oluştuktan sonra retargeting).
  const FLIGHTS = { v1: '2026-09-01', v2: '2026-09-08', v3: '2026-09-16' };
  const TL_START = new Date(START);
  const TL_END = new Date(END);
  const TL_SPAN = (TL_END - TL_START) / 86400000;
  const tlPct = (d) => (((new Date(d) - TL_START) / 86400000) / TL_SPAN) * 100;
  const fmtDay = (d) => new Date(d).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
  const durDays = (s) => Math.round((new Date(END) - new Date(s)) / 86400000) + 1;
  const LAYER_TONE = { v1: '#CC0000', v2: '#6366f1', v3: '#0d9488' };
  const tlMarks = [
    { label: '1 Eyl · Lansman', date: START },
    { label: '8 Eyl', date: '2026-09-08' },
    { label: '16 Eyl', date: '2026-09-16' },
    { label: '30 Eyl', date: END },
  ];

  // PDF: her bölüm bütün halinde basılır. Bir bölüm kalan yere sığmıyorsa
  // ortadan kesilmek yerine yeni sayfaya atılır; sadece tek başına bir sayfadan
  // uzun olan bölüm dilimlenir. Her sayfanın tepesinde Canon/Jellybon başlığı olur.
  const exportPdf = useCallback(async () => {
    if (exporting || !slideRef.current) return;
    setExporting(true);
    try {
      const root = slideRef.current;
      const headerEl = root.querySelector('[data-pdf-header]');
      const sectionEls = Array.from(root.querySelectorAll('[data-pdf-section]'));
      // html2canvas bölümü bir iframe klonunda çiziyor; genişlik sabitlenmezse
      // dipnot paragrafları fazladan satıra kayıp kutunun altından taşıyor.
      const shoot = (el) => html2canvas(el, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        width: el.offsetWidth,
        height: el.scrollHeight + 12,
        windowWidth: document.documentElement.clientWidth,
      });

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pw = pdf.internal.pageSize.getWidth();
      const ph = pdf.internal.pageSize.getHeight();
      const M = 8;
      const GAP = 6;
      const CW = pw - M * 2;
      const BOTTOM = ph - M - 6;

      const headerCanvas = await shoot(headerEl);
      const headerImg = headerCanvas.toDataURL('image/jpeg', 0.95);
      const headerH = (headerCanvas.height * CW) / headerCanvas.width;
      const TOP_Y = M + headerH + GAP;
      const PAGE_H = BOTTOM - TOP_Y;

      let pages = 0;
      let y = 0;
      const startPage = () => {
        if (pages > 0) pdf.addPage();
        pages += 1;
        pdf.addImage(headerImg, 'JPEG', M, M, CW, headerH);
        y = TOP_Y;
      };

      const slice = (canvas, srcY, srcH) => {
        const c = document.createElement('canvas');
        c.width = canvas.width;
        c.height = srcH;
        const ctx = c.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, c.width, c.height);
        ctx.drawImage(canvas, 0, srcY, canvas.width, srcH, 0, 0, canvas.width, srcH);
        return c.toDataURL('image/jpeg', 0.95);
      };

      startPage();
      for (const el of sectionEls) {
        const canvas = await shoot(el);
        const pxPerMm = canvas.width / CW;
        let srcY = 0;
        let remain = canvas.height / pxPerMm;

        while (remain > 0.5) {
          const avail = BOTTOM - y;
          if (remain <= avail) {
            const srcH = Math.round(remain * pxPerMm);
            pdf.addImage(slice(canvas, srcY, srcH), 'JPEG', M, y, CW, remain);
            y += remain + GAP;
            remain = 0;
            break;
          }
          if (remain <= PAGE_H) {
            startPage();
            continue;
          }
          const srcH = Math.round(avail * pxPerMm);
          pdf.addImage(slice(canvas, srcY, srcH), 'JPEG', M, y, CW, avail);
          srcY += srcH;
          remain -= avail;
          startPage();
        }
      }

      for (let i = 1; i <= pages; i += 1) {
        pdf.setPage(i);
        pdf.setFontSize(7);
        pdf.setTextColor(150);
        pdf.text(`Canon Corp Campaign — CORALS · Jellybon x Glowytics · ${i}/${pages}`, pw / 2, ph - M + 2, { align: 'center' });
      }

      pdf.save('Canon_CORALS_Medya_Plani.pdf');
    } catch (e) {
      console.error('PDF export failed:', e);
    } finally {
      setExporting(false);
    }
  }, [exporting]);

  const Stat = ({ label, value, sub, tone = 'gray' }) => {
    const tones = {
      gray: 'border-gray-200 bg-gray-50 text-gray-800',
      red: 'border-red-100 bg-red-50 text-red-700',
      indigo: 'border-indigo-100 bg-indigo-50 text-indigo-700',
      green: 'border-emerald-100 bg-emerald-50 text-emerald-700',
      teal: 'border-teal-100 bg-teal-50 text-teal-700',
    };
    return (
      <div className={`rounded-xl border p-4 ${tones[tone]}`}>
        <span className="text-[10px] font-medium uppercase opacity-70">{label}</span>
        <p className="text-xl font-bold mt-1">{value}</p>
        {sub && <p className="text-[10px] opacity-60 mt-0.5">{sub}</p>}
      </div>
    );
  };

  const LayerPill = ({ layer, tone }) => (
    <span
      className="text-[9px] font-semibold px-2 py-0.5 rounded-full border whitespace-nowrap"
      style={{ color: tone, borderColor: tone + '33', background: tone + '0f' }}
    >{layer}</span>
  );

  return (
    <div className="p-4 md:p-6 max-w-5xl mx-auto">
      <div className="flex justify-end mb-3">
        <button
          onClick={exportPdf}
          disabled={exporting}
          className="text-white text-sm font-semibold px-4 py-2 rounded-lg shadow-sm disabled:opacity-60"
          style={{ background: '#CC0000' }}
        >
          {exporting ? 'PDF Oluşturuluyor…' : 'PDF Olarak İndir'}
        </button>
      </div>

      <div ref={slideRef} className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        {/* Header */}
        <div data-pdf-header className="bg-white border-b px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src="/Canon_logo_vector.png" alt="Canon" className="h-12 w-auto object-contain" />
            <div className="h-8 w-px bg-gray-200" />
            <div>
              <p className="text-xs font-bold text-gray-800">Canon Corp Campaign — CORALS · Medya Planı</p>
              <p className="text-[9px] text-gray-400">World Unseen · Meta Ads (FB + IG) · 3 Video · 30 gün</p>
            </div>
          </div>
          <img src="/Jellybon-digital-agency-istanbul.webp" alt="Jellybon" className="h-12 w-auto object-contain" />
        </div>

        <div className="p-6 space-y-6">
          {/* Kampanya detayı */}
          <div data-pdf-section className="rounded-xl border border-red-100 bg-red-50 p-4">
            <p className="text-sm font-bold text-gray-800">Kampanya Detayı</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              Canon'un kurumsal <strong>World Unseen</strong> projesinin bir parçası olan
              <strong> Canon Corp Campaign — CORALS</strong> iletişimi. Global tarafın verdiği KPI
              <strong> web sitesinin ilgili alanına yönlendirme</strong> olduğu için üç kampanyanın da hedefi
              <strong> Trafik</strong>. Planın omurgası erişim değil <strong>link tıklaması</strong>; video
              izlenme ve izlenme derinliği (ThruPlay) ikincil okunur.
            </p>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              3 video, Meta Ads (Facebook + Instagram). Videolar aynı, ayrışan şey kitle katmanı: bütçe geniş
              kitleden başlar, ilgi alanı ile daralır, son videoda ilk iki videoyu izlemiş kitleye retargeting yapar.
            </p>
          </div>

          {/* Açık varsayımlar */}
          <div data-pdf-section className="rounded-xl border border-amber-200 bg-amber-50 p-4">
            <p className="text-sm font-bold text-gray-800">Onay Bekleyen Varsayımlar</p>
            <ul className="text-xs text-gray-700 mt-1.5 space-y-1 list-disc list-inside leading-relaxed">
              <li>
                <strong>Tarih iletilmedi.</strong> Plan <strong>1 – 30 Eylül 2026</strong> (30 gün) üzerine
                kuruldu. Farklı bir pencere verilirse günlük dağılım ve frekans varsayımı yeniden hesaplanır.
              </li>
              <li>
                <strong>Stopaj oranı yazılmamıştı</strong> — Canon standardı <strong>%15</strong> alındı.
              </li>
              <li>
                <strong>Tasarım kalemi yok.</strong> 3 videonun hazır teslim edileceği varsayıldı; üretim
                bütçesi gerekirse net medyadan düşülür.
              </li>
              <li>
                <strong>Video süreleri ve formatları iletilmedi.</strong> Yerleşim dağılımı Feed + Reels/Stories
                olarak varsayıldı; dikey (1080×1920) versiyon yoksa Reels/Stories erişimi düşer.
              </li>
            </ul>
          </div>

          {/* Bütçe kırılımı */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-2">Bütçe Kırılımı</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <Stat label="Toplam Bütçe" value={fmtCur(TOTAL)} sub="müşteri toplam" />
              <Stat label="AHK (Ajans %10)" value={'-' + fmtCur(AHK_FEE)} sub={`${fmtCur(TOTAL)} × 0,10`} tone="indigo" />
              <Stat label="Stopaj (%15)" value={'-' + fmtCur(STOPAJ)} sub={`${fmtCur(MEDIA_BRUT)} × 0,15`} tone="indigo" />
              <Stat label="NET Medya" value={fmtCur(NET)} sub="Meta'da harcanan" tone="green" />
            </div>
            <p className="text-[10px] text-gray-400 mt-2">
              Günlük ortalama net harcama ≈ {fmtCur(dailyNet)} ({DAYS} gün). AHK + Stopaj toplam
              {' '}{fmtCur(TOTAL)}'ye dahildir. Brüt medya {fmtCur(MEDIA_BRUT)}. Tasarım kalemi bu kırılımda yoktur.
            </p>
          </div>

          {/* Hedef dağılımı */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-1">Kitle Katmanı Dağılımı</p>
            <p className="text-[10px] text-gray-400 mb-3">
              Üç kampanyanın da hedefi <strong>Trafik</strong>; ayrışma hedefte değil kitlededir. Bütçe geniş
              kitleden retargeting'e doğru kademelenir — son video, ilk iki videonun izleyici havuzu oluştuktan
              sonra açılır ve en sıcak kitleye net bir çağrı yapar.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              {layerSummary.map((g) => (
                <div key={g.key} className="rounded-xl border border-gray-200 p-3">
                  <div className="flex items-center justify-between gap-2">
                    <LayerPill layer={g.layer} tone={LAYER_TONE[g.key]} />
                    <span className="text-[10px] font-bold text-gray-500 tabular-nums">%{g.pct.toFixed(0)}</span>
                  </div>
                  <p className="text-lg font-bold text-gray-800 mt-1.5 tabular-nums">{fmtCur(g.budget)}</p>
                  <p className="text-[10px] text-gray-500 mt-0.5 tabular-nums">
                    {fmtInt(g.impressions)} gösterim · {fmtInt(g.clicks)} link tık
                  </p>
                  <div className="mt-2 h-1.5 rounded-full bg-gray-100 overflow-hidden">
                    <div className="h-full rounded-full" style={{ width: `${g.pct}%`, background: LAYER_TONE[g.key] }} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Video bazında tablo */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-2">Video Bazında Bütçe ve Projeksiyon (3 Video)</p>
            <div className="overflow-x-auto rounded-xl border border-gray-200">
              <table className="w-full text-xs">
                <thead>
                  <tr className="bg-gray-50 text-gray-500 uppercase text-[10px]">
                    <th className="text-left px-3 py-2 font-semibold">Video</th>
                    <th className="text-left px-3 py-2 font-semibold">Yayın</th>
                    <th className="text-right px-3 py-2 font-semibold">Bütçe (NET)</th>
                    <th className="text-right px-3 py-2 font-semibold">Gösterim</th>
                    <th className="text-right px-3 py-2 font-semibold">Link Tık</th>
                    <th className="text-right px-3 py-2 font-semibold">CPC</th>
                    <th className="text-right px-3 py-2 font-semibold">Video İzlenme</th>
                    <th className="text-right px-3 py-2 font-semibold">CPM</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {rows.map((r) => (
                    <tr key={r.key} className="hover:bg-gray-50">
                      <td className="px-3 py-2">
                        <p className="font-semibold text-gray-800 whitespace-nowrap">{r.title}</p>
                        <p className="text-[9px] text-gray-400">{r.role}</p>
                        <p className="text-[9px] text-gray-300">{r.placement}</p>
                        <div className="mt-1"><LayerPill layer={r.layer} tone={LAYER_TONE[r.key]} /></div>
                      </td>
                      <td className="px-3 py-2 text-gray-500 whitespace-nowrap">
                        {fmtDay(FLIGHTS[r.key])} → {fmtDay(END)}
                        <span className="text-gray-300"> · {durDays(FLIGHTS[r.key])}g</span>
                      </td>
                      <td className="px-3 py-2 text-right tabular-nums font-semibold">
                        {fmtCur(r.budget)}
                        <span className="block text-[9px] font-normal text-gray-400">%{Math.round((r.budget / NET) * 100)}</span>
                      </td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtInt(r.impressions)}</td>
                      <td className="px-3 py-2 text-right tabular-nums font-semibold text-indigo-700">{fmtInt(r.clicks)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">₺{r.cpc.toFixed(2)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">{fmtInt(r.views)}</td>
                      <td className="px-3 py-2 text-right tabular-nums">₺{r.cpm.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-red-50 font-bold text-gray-800">
                    <td className="px-3 py-2" colSpan={2}>TOPLAM</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtCur(totals.budget)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtInt(totals.impressions)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtInt(totals.clicks)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">₺{blendedCpc.toFixed(2)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">{fmtInt(totals.views)}</td>
                    <td className="px-3 py-2 text-right tabular-nums">₺{blendedCpm.toFixed(2)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <p className="text-[10px] text-gray-400 mt-2">
              <strong>Link Tık</strong> = siteye yönlendiren tıklama (Meta'da <em>inline link click</em>); tüm
              tıklamalar değil, KPI'ın karşılığı olan metrik budur. Tahmini erişim {fmtInt(estReach)}
              {' '}(~{FREQ} frekans), beklenen CTR %{ctr.toFixed(2)}. <strong>Video İzlenme</strong> = 3 saniye ve
              üzeri izleme, <strong>ThruPlay</strong> = 15 saniye veya videonun tamamı. Toplam link tıklaması
              ≈ {fmtInt(totals.thruplays)} (₺{cptp.toFixed(2)}).
            </p>
          </div>

          {/* Projeksiyon özeti */}
          <div data-pdf-section className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <Stat label="Site Yönlendirme (Link Tık)" value={fmtInt(totals.clicks)} sub={`birincil KPI · CPC ₺${blendedCpc.toFixed(2)}`} tone="green" />
            <Stat label="Toplam Gösterim" value={fmtInt(totals.impressions)} sub={`CPM ₺${blendedCpm.toFixed(2)}`} tone="red" />
            <Stat label="Video İzlenme" value={fmtInt(totals.views)} sub={`3 sn+ · CPV ₺${cpv.toFixed(3)}`} tone="teal" />
            <Stat label="ThruPlay" value={fmtInt(totals.thruplays)} sub={`15 sn / tam · ₺${cptp.toFixed(2)}`} tone="teal" />
          </div>

          {/* Yayın takvimi */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-1">Yayın Takvimi</p>
            <p className="text-[10px] text-gray-400 mb-3">
              Ana film baştan sona yayında kalır. Hikâye videosu 2. haftada devreye girer; yönlendirme videosu
              16 Eylül'de açılır çünkü o noktada ilk iki videonun izleyici havuzu retargeting için yeterli
              büyüklüğe ulaşır.
            </p>
            <div className="rounded-xl border border-gray-200 p-4 overflow-hidden">
              <div className="flex">
                <div className="w-40 md:w-56 shrink-0" />
                <div className="relative flex-1 h-4">
                  {tlMarks.map((m, i) => (
                    <span
                      key={m.label}
                      className="absolute top-0 text-[9px] font-semibold text-gray-400 whitespace-nowrap"
                      style={{
                        left: `${tlPct(m.date)}%`,
                        transform: i === 0 ? 'none' : i === tlMarks.length - 1 ? 'translateX(-100%)' : 'translateX(-50%)',
                      }}
                    >
                      {m.label}
                    </span>
                  ))}
                </div>
              </div>

              <div className="relative mt-1.5">
                <div className="absolute inset-0 flex pointer-events-none">
                  <div className="w-40 md:w-56 shrink-0" />
                  <div className="relative flex-1">
                    {tlMarks.map((m) => (
                      <div key={m.label} className="absolute top-0 bottom-0 w-px bg-gray-100" style={{ left: `${tlPct(m.date)}%` }} />
                    ))}
                  </div>
                </div>

                {rows.map((r) => {
                  const left = tlPct(FLIGHTS[r.key]);
                  const width = Math.max(100 - left, 2);
                  const nearEnd = left > 60;
                  return (
                    <div key={r.key} className="flex items-center h-12 relative">
                      <div className="w-40 md:w-56 shrink-0 pr-3">
                        <p className="text-[11px] font-semibold text-gray-800 whitespace-nowrap" style={{ lineHeight: '1.5' }}>{r.title}</p>
                        <div className="flex items-center justify-between gap-1">
                          <span className="text-[9px] text-gray-400">{r.goal}</span>
                          <span className="text-[9px] font-bold tabular-nums" style={{ color: LAYER_TONE[r.key] }}>
                            {fmtCur(r.budget)} · %{Math.round((r.budget / NET) * 100)}
                          </span>
                        </div>
                      </div>
                      <div className="relative flex-1 h-12">
                        <div className="absolute top-1/2 -translate-y-1/2" style={{ left: `${left}%`, width: `${width}%` }}>
                          <div className={`absolute bottom-full mb-1 whitespace-nowrap text-[8.5px] font-medium text-gray-500 ${nearEnd ? 'right-0' : 'left-0'}`}>
                            {fmtDay(FLIGHTS[r.key])} → {fmtDay(END)} · {durDays(FLIGHTS[r.key])}g
                          </div>
                          <div className="h-4 rounded-full shadow-sm" style={{ background: LAYER_TONE[r.key] }} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="flex flex-wrap items-center justify-between gap-3 mt-4 pt-3 border-t border-gray-100">
                <div className="flex flex-wrap items-center gap-3">
                  {rows.map((r) => (
                    <span key={r.key} className="flex items-center gap-1.5 text-[9px] text-gray-500">
                      <span className="w-3 h-3 rounded-full" style={{ background: LAYER_TONE[r.key] }} />{r.layer}
                    </span>
                  ))}
                </div>
                <span className="text-[9px] text-gray-400">
                  Toplam paid: <strong className="text-gray-600">{fmtCur(NET)}</strong> · {DAYS} gün
                </span>
              </div>
            </div>
          </div>

          {/* Hedefleme */}
          <div data-pdf-section>
            <p className="text-sm font-bold text-gray-800 mb-2">Hedefleme</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <Stat label="Birincil Kitle" value="Geniş kitle" sub="kurumsal marka anlatımı" tone="red" />
              <Stat label="Yaş / Cinsiyet" value="25–55" sub="Tüm cinsiyetler" />
              <Stat label="Dil / Lokasyon" value="Türkiye" sub="TR yerleşik" />
              <Stat label="Platform" value="FB + IG" sub="Feed · Reels · Stories" />
            </div>

            <div className="mt-3 rounded-xl border border-gray-200 bg-gray-50 p-3">
              <span className="text-[10px] font-medium uppercase text-gray-500">Kurgu</span>
              <p className="text-xs text-gray-700 mt-1 leading-relaxed">
                Üç kampanya da Trafik hedefinde olduğu için Meta her katmanda <strong>tıklayacak kişiyi</strong>
                arar. İlk katmanda hedefleme yine de geniş tutulur — kurumsal anlatımda erken daraltma tıklama
                maliyetini yükseltir. İkinci katman ilgi alanı ve benzer kitleyle daraltılır, üçüncü katmanda
                öncelik <strong>videoyu izlemiş kitleye</strong> verilir; en düşük tıklama maliyeti burada beklenir.
              </p>
            </div>

            <div className="mt-3 rounded-xl border border-gray-200 p-3">
              <span className="text-[10px] font-medium uppercase text-gray-500">İlgi Alanları (2. katman için)</span>
              <div className="flex flex-wrap gap-1.5 mt-2">
                {['Fotoğrafçılık', 'Doğa & vahşi yaşam', 'Deniz ve okyanus', 'Sürdürülebilirlik',
                  'Çevre koruma', 'Belgesel', 'Sanat & sergi', 'Bilim & keşif', 'Erişilebilirlik & kapsayıcılık',
                  'Sosyal sorumluluk', 'Dalış & sualtı', 'Görsel sanatlar'].map((t) => (
                  <span key={t} className="text-[10px] px-2 py-1 rounded-full bg-red-50 text-red-700 border border-red-100">{t}</span>
                ))}
              </div>
            </div>

            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-3">
                <span className="text-[10px] font-medium uppercase text-emerald-700">Özel Kitleler (Custom Audience)</span>
                <ul className="text-[11px] text-gray-700 mt-1.5 space-y-1 list-disc list-inside leading-relaxed">
                  <li>Video 1 ve 2'yi %25+ izleyenler — Video 3'ün ana havuzu</li>
                  <li>Son 365 gün IG/FB sayfa & post etkileşimcileri</li>
                  <li>World Unseen sayfası ziyaretçileri (Pixel)</li>
                </ul>
              </div>
              <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-3">
                <span className="text-[10px] font-medium uppercase text-emerald-700">Benzer Kitleler (Lookalike)</span>
                <ul className="text-[11px] text-gray-700 mt-1.5 space-y-1 list-disc list-inside leading-relaxed">
                  <li>Video izleyiciler LAL %1–3 (TR)</li>
                  <li>Etkileşimciler LAL %2 (TR)</li>
                </ul>
              </div>
            </div>

            <p className="text-[10px] text-gray-400 mt-2">
              Video izleyici havuzu ilk 10–14 günde oluşur; Video 3 bu yüzden 16 Eylül'de açılır. Havuz
              beklenenden hızlı dolarsa açılış öne çekilir.
            </p>
          </div>

          {/* Benchmark dayanağı */}
          <div data-pdf-section className="rounded-xl border border-amber-100 bg-amber-50 p-4">
            <p className="text-sm font-bold text-gray-800">Projeksiyonun Dayanağı</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              Buradaki CPM ve CPC değerleri sektör ortalaması değil, <strong>Canon'un kendi Meta hesabında
              trafik hedefiyle gerçekleşen</strong> rakamlardır (Haz–Ağu 2026). Awareness kırılımı bu planda
              kullanılmaz. Plan tabanı yalnızca <strong>Feed + Reels</strong> yerleşimlerinden alınmıştır; <strong>izlenme ve ThruPlay
              oranları</strong> ise yalnızca <strong>gerçek video kreatifli</strong> kampanyalardan alınmıştır —
              adında “Video” geçen ama statik görselli yarışma kampanyaları o orana katılmamıştır (izlenmeleri
              sıfır dönüyor ve ortalamayı bozuyor).
            </p>
            <div className="overflow-x-auto rounded-lg border border-amber-200 bg-white mt-2">
              <table className="w-full text-[11px]">
                <thead>
                  <tr className="bg-amber-50/60 text-gray-500 uppercase text-[9px]">
                    <th className="text-left px-3 py-1.5 font-semibold">Hedef × Video</th>
                    <th className="text-right px-3 py-1.5 font-semibold">Harcama</th>
                    <th className="text-right px-3 py-1.5 font-semibold">Gösterim</th>
                    <th className="text-right px-3 py-1.5 font-semibold">CPM</th>
                    <th className="text-right px-3 py-1.5 font-semibold">İzlenme %</th>
                    <th className="text-right px-3 py-1.5 font-semibold">ThruPlay %</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-amber-100">
                  {[
                    ['Trafik · Feed + Reels (plan tabanı)', TR_SAMPLE, 6415817, TR_CPM, null, null],
                    ['Trafik × gerçek video kreatifi (Feed + Reels)', VIDEO_SAMPLE, 113626, VIDEO_CPM, VIEW_RATE * 100, THRU_RATE * 100],
                    ['Story ve diğerleri (plan dışı)', 114701, 2254751, 50.87, null, null],
                  ].map(([n, s, imp, cpm, vr, tr]) => (
                    <tr key={n}>
                      <td className="px-3 py-1.5 font-medium text-gray-700">{n}</td>
                      <td className="px-3 py-1.5 text-right tabular-nums text-gray-500">{fmtCur(s)}</td>
                      <td className="px-3 py-1.5 text-right tabular-nums text-gray-500">{fmtInt(imp)}</td>
                      <td className="px-3 py-1.5 text-right tabular-nums">₺{cpm.toFixed(2)}</td>
                      <td className="px-3 py-1.5 text-right tabular-nums">{vr === null ? <span className="text-gray-300">—</span> : '%' + vr.toFixed(2)}</td>
                      <td className="px-3 py-1.5 text-right tabular-nums">{tr === null ? <span className="text-gray-300">—</span> : '%' + tr.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              Plan tabanı, Canon'un Haz–Ağu 2026 arasındaki trafik kampanyalarının <strong>Feed + Reels</strong>
              ortalamasıdır; o kampanyaların çoğu statik görsel ve karuseldir. CORALS ise üç video ile
              yayınlanacak ve video kreatifinin trafik CPM'i (<strong>₺{VIDEO_CPM.toFixed(2)}</strong>) bu
              ortalamanın üzerinde gerçekleşiyor — aşağıdaki duyarlılık bölümüne bakınız.
              <br />
              ⚠️ Video kırılımının örneklemi küçüktür ({fmtCur(VIDEO_SAMPLE)} harcama, 4 kampanya); yön bilgisi
              olarak güvenilir, nokta tahmini olarak değil. İlk hafta sonunda yeniden kalibre edilir.
            </p>
          </div>

          {/* Yerleşim gerekçesi */}
          <div data-pdf-section className="rounded-xl border border-sky-200 bg-sky-50 p-4">
            <p className="text-sm font-bold text-gray-800">Neden Yalnızca Feed + Reels?</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              Canon'un aylık trafik rakamlarına ham haliyle bakıldığında Temmuz diğer aylardan çok pahalı
              görünüyordu (CPC ₺2,63'e karşı Haziran ₺1,63, Ağustos ₺1,41). Kırılıma inilince fark ayın
              kendisinden değil <strong>yerleşim karmasından</strong> çıktı: Temmuz'da trafik bütçesinin
              <strong> %45'i Story'ye</strong> gitmiş, Ağustos'ta bu oran yalnızca %13. Story, tıklama
              hedefinde Feed + Reels'ten belirgin biçimde pahalı:
            </p>
            <div className="overflow-x-auto rounded-lg border border-sky-200 bg-white mt-2">
              <table className="w-full text-[11px]">
                <thead>
                  <tr className="bg-sky-50/60 text-gray-500 uppercase text-[9px]">
                    <th className="text-left px-3 py-1.5 font-semibold">Yerleşim (Haz–Ağu, trafik)</th>
                    <th className="text-right px-3 py-1.5 font-semibold">Harcama</th>
                    <th className="text-right px-3 py-1.5 font-semibold">CPM</th>
                    <th className="text-right px-3 py-1.5 font-semibold">CPC (link)</th>
                    <th className="text-right px-3 py-1.5 font-semibold">CTR %</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-sky-100">
                  <tr className="bg-sky-50/40">
                    <td className="px-3 py-1.5 font-semibold text-gray-800">Feed + Reels <span className="font-normal text-gray-400">(plan)</span></td>
                    <td className="px-3 py-1.5 text-right tabular-nums text-gray-500">₺176.837</td>
                    <td className="px-3 py-1.5 text-right tabular-nums font-semibold">₺27,56</td>
                    <td className="px-3 py-1.5 text-right tabular-nums font-semibold">₺1,91</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">%1,44</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-1.5 font-medium text-gray-700">Story ve diğerleri <span className="text-gray-400">(plan dışı)</span></td>
                    <td className="px-3 py-1.5 text-right tabular-nums text-gray-500">₺114.701</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">₺50,87</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">₺3,32</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">%1,53</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              Story tıklama başına <strong>~1,7 kat</strong> pahalı. KPI site yönlendirme olduğu için CORALS
              <strong> Feed + Reels'te</strong> planlanır ve plan tabanı da aynı yerleşimden alınır — böylece
              aylar birbiriyle gerçekten kıyaslanabilir hale gelir. Story tamamen kapatılmaz; ilk hafta sonunda
              küçük bir test payıyla açılır, tıklama maliyeti tutarsa ağırlığı artırılır.
            </p>
          </div>

          {/* Video kreatif duyarlılığı */}
          <div data-pdf-section className="rounded-xl border border-orange-200 bg-orange-50 p-4">
            <p className="text-sm font-bold text-gray-800">Duyarlılık — Video Kreatifi Trafiği Pahalılaştırıyor</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              Plan tabanı ({fmtCur(TR_SAMPLE)} gerçekleşen harcama) Canon'un Feed + Reels trafik
              kampanyalarının ortalamasıdır; çoğu statik görsel ve karuseldir. CORALS <strong>üç video</strong> ile yayınlanacak.
              Canon'un trafik hedefli video kampanyalarında gerçekleşen CPM <strong>₺{VIDEO_CPM.toFixed(2)}</strong>,
              tıklama <strong>₺{VIDEO_CPC.toFixed(2)}</strong>. Gerçekleşme büyük ihtimalle bu iki senaryonun
              arasında olacaktır.
            </p>
            <div className="grid grid-cols-2 gap-3 mt-3">
              <div className="rounded-lg border border-orange-200 bg-white p-3">
                <p className="text-[10px] font-semibold uppercase text-gray-500">İyimser — Feed + Reels ortalaması</p>
                <p className="text-lg font-bold text-gray-800 mt-1">{fmtInt(totals.impressions)} <span className="text-xs font-normal text-gray-400">gösterim</span></p>
                <p className="text-[11px] text-gray-600">{fmtInt(totals.clicks)} link tık · CPM ₺{blendedCpm.toFixed(2)} · CPC ₺{blendedCpc.toFixed(2)}</p>
              </div>
              <div className="rounded-lg border border-orange-300 bg-white p-3">
                <p className="text-[10px] font-semibold uppercase text-gray-500">Temkinli — video kreatifi</p>
                <p className="text-lg font-bold text-gray-800 mt-1">{fmtInt(sensImpressions)} <span className="text-xs font-normal text-gray-400">gösterim</span></p>
                <p className="text-[11px] text-gray-600">{fmtInt(sensClicks)} link tık · CPM ₺{VIDEO_CPM.toFixed(2)} · CPC ₺{VIDEO_CPC.toFixed(2)}</p>
              </div>
            </div>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              Temkinli senaryo, iyimserin <strong>%{Math.abs(sensDelta)} altında</strong> gösterim üretir.
              ⚠️ Video kırılımının örneklemi {fmtCur(VIDEO_SAMPLE)} harcamadır (4 kampanya) — yön bilgisi olarak
              güvenilir, nokta tahmini olarak değil. Sunumda taahhüt edilecek rakam temkinli senaryodan seçilmelidir.
            </p>
          </div>

          {/* Ölçüm ön koşulu */}
          <div data-pdf-section className="rounded-xl border border-rose-200 bg-rose-50 p-4">
            <p className="text-sm font-bold text-gray-800">Ölçüm Ön Koşulu — KPI'ın Raporlanabilmesi İçin</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              KPI “web sitesinin ilgili alanına yönlendirme” olduğuna göre plan iki farklı metrikle raporlanabilir
              ve ikisi aynı şey değildir:
            </p>
            <ul className="text-xs text-gray-600 mt-2 space-y-1.5 list-disc pl-5 leading-relaxed">
              <li>
                <strong>Link tıklaması</strong> — Meta tarafında her koşulda ölçülür, ek kurulum gerektirmez.
                Planın taahhüt ettiği metrik budur.
              </li>
              <li>
                <strong>Landing page view (siteye ulaşan ziyaretçi)</strong> — yalnızca hedef sayfada
                <strong> Canon TR piksel'i</strong> varsa ölçülür. World Unseen global bir Canon mülkü olduğu için
                bu piksel orada büyük ihtimalle <strong>yoktur</strong>; o durumda siteye kaç kişinin ulaştığını
                Meta panelinden raporlayamayız.
              </li>
            </ul>
            <p className="text-[11px] text-gray-600 mt-2 leading-relaxed">
              Kampanya başlamadan önce ikisinden biri netleşmeli: <strong>(a)</strong> hedef sayfaya Canon TR
              piksel'i eklenir, ya da <strong>(b)</strong> global'in GA4'üne UTM'li raporlama erişimi alınır.
              Aksi halde global'e “siteye şu kadar kişi geldi” denemez, yalnızca “şu kadar tık gönderildi” denebilir.
            </p>
            <p className="text-[10px] text-gray-500 mt-2 leading-relaxed">
              Referans: Canon'un trafik hedefli video kampanyalarında landing page view / link tıklaması oranı
              <strong> %{(LPV_PER_LINK * 100).toFixed(1)}</strong> gerçekleşmiştir. Bu oran geçerli olursa plan
              ≈ <strong>{fmtInt(totals.lpv)}</strong> siteye ulaşan ziyaret üretir (₺{cplpv.toFixed(2)}).
              Oran hesabın tamamında %0,7 ile %37 arasında salınıyor — ölçüm kurulumu netleşmeden bu rakam
              taahhüt edilmemelidir.
            </p>
          </div>

          {/* Zamanlama */}
          <div data-pdf-section className="rounded-xl border border-gray-200 bg-gray-50 p-4">
            <p className="text-sm font-bold text-gray-800">Zamanlama & Optimizasyon</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              Yayın: <strong>1 – 30 Eylül 2026</strong> ({DAYS} gün, onaya tabi), kesintisiz. Ana film 1 Eylül'de,
              hikâye videosu 8 Eylül'de, yönlendirme videosu 16 Eylül'de açılır. İlk 7 gün öğrenme fazı sonunda
              yerleşim (Feed / Reels / Stories) ve video ağırlıkları <strong>tıklama maliyetine</strong> göre
              yeniden dağıtılır. KPI site yönlendirme olduğu için raporlamada birincil metrik
              <strong> link tıklaması ve CPC</strong>; erişim ile izlenme derinliği ikincil okunur.
            </p>
          </div>

          {/* Footer */}
          <div className="flex justify-between items-center pt-3 border-t border-gray-100">
            <img src="/Canon_logo_vector.png" alt="Canon" className="h-7 w-auto object-contain" />
            <p className="text-[9px] text-gray-400">
              {new Date().toLocaleDateString('tr-TR')} · Confidential · Jellybon × Glowytics
            </p>
            <img src="/Jellybon-digital-agency-istanbul.webp" alt="Jellybon" className="h-6 w-auto object-contain" />
          </div>
        </div>
      </div>
    </div>
  );
}
